import { useAbility } from 'utilities/ability'

// Each flag mirrors the permission the backing nexus endpoint enforces, so we
// never fire a request that would 403 and toast "Missing permission".
//   GET /tiers     -> `view tiers_program` -> CASL `TiersProgram`
//   GET /locations -> `view locations`     -> CASL `Locations`
// (`Tiers` is NOT equivalent: the `loyalty` resource grants it too.)
// CASL `manage` implies every action, so `can('access', ...)` covers it.
const useProfilePermissions = () => {
  const ability = useAbility()

  return {
    canAccessTiers: ability.can('access', 'TiersProgram'),
    canAccessLocations: ability.can('access', 'Locations'),
  }
}

export default useProfilePermissions
